// extracted by mini-css-extract-plugin
module.exports = {"playerWrap":"styles_playerWrap__3q-5z","iframeItem":"styles_iframeItem__1okRy"};